import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';
import './Chart.css';
import { useTheme } from '../contexts/ThemeContext';
import { getChartJsOptions } from '../Utils/chartTheme';

interface ChartProps {
    labels: string[];
    chartData: number[][];
}

function formatCurrency(value: string | number) {
    const number = Number(value);
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,  // No decimal places
        maximumFractionDigits: 0,  // No decimal places
    });
}

const IncomeTaxChart: React.FC<ChartProps> = ({labels, chartData}) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart | null>(null);
  const { actualTheme } = useTheme();

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const ctx = chartRef.current.getContext('2d');
      if (ctx) {
        if (chartInstance.current) {
            chartInstance.current.destroy();
        }
        
        const isDark = actualTheme === 'dark';
        const options = getChartJsOptions(isDark, formatCurrency);
        
        // Override some specific options for this chart
        const customOptions = {
          ...options,
          scales: {
            ...options.scales,
            x: {
              ...options.scales.x,
              grid: {
                ...options.scales.x.grid,
                display: false
              }
            }
          }
        };

        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Taxes Owed',
                    data: chartData[0],
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)', 
                        'rgba(255, 99, 132, 0.2)', 
                        'rgba(255, 99, 132, 0.2)', 
                        'rgba(255, 99, 132, 0.2)', 
                        'rgba(255, 99, 132, 0.6)',
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)', 
                        'rgba(255, 99, 132, 1)', 
                        'rgba(255, 99, 132, 1)', 
                        'rgba(255, 99, 132, 1)', 
                        'rgba(255, 99, 132, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
            },
            options: customOptions,
          });
      }
    }
  }, [chartData, labels, actualTheme]);

  return (
    <div className="chart-container">
      <canvas ref={chartRef} style={{ width: '100%', height: '100%' }}></canvas>
    </div>
  );
};

export default IncomeTaxChart;
